import { useEffect, useState, useMemo } from "react";
import { PlusCircleOutlined, MoreOutlined } from "@ant-design/icons";
import { Spin, Modal, Button, Dropdown } from "antd";
import TableComponent from "../../components/TableComponent";
import { createColumn } from "../../utils/tableUtils";
import { useNavigate } from "react-router-dom";
import { tableDateFormatter } from "../../utils/formatDate";
import MainButtonComponent from "../../components/MainButtonComponent";
import {
	HeaderComponent,
	Container,
	ContainerHeader,
	ActionButtonOverlay,
} from "../../components/styled/common";
import { useCDNFileContext } from "../../context/CDNFileContext/CDNFileContext";

const CDNFileList = () => {
	const [tableData, setTableData] = useState<any[]>([]);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [currentItem, setCurrentItem] = useState<any>(null);
	const { cdnFileList, getCDNFileList, operationStatus, removeCDNFile, clearCDNFileList } = useCDNFileContext();


	const navigate = useNavigate();

	useEffect(() => {
		clearCDNFileList();
		getCDNFileList();

		return () => {
			clearCDNFileList();
		};
	}, []);

	useEffect(() => {
		setTableData(cdnFileList);
	}, [cdnFileList]);

	const columns = useMemo(() => [
		createColumn({
			title: "Dosya Adı",
			dataIndex: "name",
			width: 100,
			sorterType: "string",
		}),
		createColumn({
			title: "Url",
			dataIndex: "imageUrl",
			width: 200,
			sorterType: "string",
			render: (url) => (
				<a href={url} target="_blank" rel="noopener noreferrer">
					{url}
				</a>
			),
		}),
		createColumn({
			title: "Boyut",
			dataIndex: "size",
			width: 60,
			sorterType: "numeric"
		}),
		createColumn({
			title: "Dosya Tipi",
			dataIndex: "extension",
			width: 60,
			sorterType: "string"
		}),
		createColumn({
			title: "Çerçeve",
			dataIndex: "width",
			width: 60,
			sorterType: "string",
			render: (_, record: any) =>
				record?.width != null && record?.height != null
					? `${record.width}x${record.height}`
					: "-",
		}),
		createColumn({
			title: "Tarih",
			dataIndex: "creationDate",
			width: 50,
			sorterType: "string",
			render: (text) => tableDateFormatter(text, "DD.MM.YYYY"),
		}),
		createColumn({
			title: "",
			dataIndex: "action",
			width: 20,
			render: (text, record: any) => {
				const menuItems = [
					{
						key: "edit",
						label: "Güncelle",
						onClick: () => navigate(`/edit-cdn-file/${record.cdnFileId}`),
					},
					{
						key: "delete",
						label: "Sil",
						onClick: () => {
							setCurrentItem(record);
							setIsModalVisible(true);
						},
					},
				];

				return (
					<Dropdown menu={{ items: menuItems }} trigger={["click"]}>
						<MoreOutlined />
					</Dropdown>
				);
			},
		}),
	], [navigate]);


	return (
		<div>
			<HeaderComponent>CDN Dosyaları</HeaderComponent>
			<Container>
				<Spin spinning={operationStatus.type === "loading" && operationStatus.operation === "fetch"}>
					<ContainerHeader>
						<ActionButtonOverlay>
							<MainButtonComponent
								style={{ marginRight: "15px" }}
								icon={<PlusCircleOutlined />}
								onClick={() => navigate("/add-cdn-file")}
							>
								Yeni Ekle
							</MainButtonComponent>
						</ActionButtonOverlay>
					</ContainerHeader>
				</Spin>
				{!(operationStatus.type === "loading" && operationStatus.operation === "fetch") && (
					<TableComponent
						columns={columns}
						dataSource={tableData}
					/>
				)}
			</Container>
			<Modal
				title="CDN Dosyasını Sil"
				open={isModalVisible}
				centered
				onCancel={() => setIsModalVisible(false)}
				footer={[
					<Button key="back" type="text" onClick={() => setIsModalVisible(false)}>
						İptal
					</Button>,
					<Button
						loading={operationStatus.type === "loading" && operationStatus.operation === "delete"}
						key="submit"
						type="primary"
						danger
						onClick={async () => {
							await removeCDNFile(currentItem?.cdnFileId);
							setIsModalVisible(false);
						}}
					>
						Evet
					</Button>,
				]}
			>
				<p><strong>{`"${currentItem?.name}"`}</strong> dosyasını silmek istediğinizden emin misiniz?</p>
			</Modal>
		</div>
	);
};

export default CDNFileList;
